import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const RequireAdmin = ({ children }) => {
  const { user } = useAuth();

  if (!user || user.role !== 3) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default RequireAdmin;
